import { useState, useEffect } from "react";
import { errorServiceFactory } from "../../services/ErrorServiceImpl";
import { StatusCodes } from "http-status-codes";
import { ApiResponseStatus } from "../../domain/enums/common/ApiResponseStatusEnum";

const errorService = errorServiceFactory();

export function useErrorHandler(errorType: StatusCodes = null, customErrorKey: string = "") {
    const [errorSubject, setErrorSubject] = useState(errorService.getApiErrorSubject());

    useEffect(() => {
        const subscription = errorService.subscribeOnError((subject) => {
            setErrorSubject({ ...subject, errorKey: customErrorKey || subject.errorKey });
        });
        return () => {
            subscription.unsubscribe();
            errorService.resetErrorResponseSubject();
        };
    }, []);

    const resetErrors = () => {
        setErrorSubject(errorService.resetErrorResponseSubject());
    };

    const isError = () => errorService.getApiErrorSubject().statusCode === errorType;
    const isLoading = () => errorService.getApiErrorSubject().status === ApiResponseStatus.LOADING;

    return {
        resetErrors,
        isError,
        isLoading,
        errorKey: isError() ? errorSubject.errorKey : "",
    };
}
